import { BaseLayout } from '@uag/react-core';

import { FlexLayoutContainer } from 'app/modules/wallforming/components/FlexLayoutContainer';
export const WallForming = () => {

    return (
        <div className="max-h-screen max-w-screen overflow-hidden" id="wallformingWindow">
            <BaseLayout
                className="bg-background-gray-ultra-ultra-light overflow-hidden"
                environment={import.meta.env.VITE_ENVIRONMENT}
                innerClassName="h-full w-full overflow-hidden"
                showFooter={true}
                versionNumber={APP_VERSION}
                withCookieBanner={false}
            >
                <FlexLayoutContainer />
            </BaseLayout>
        </div>
    );
};